import React from 'react';
import messages from '../../displayMessages';
import { WrappedMessage } from 'utils';
import { intl } from 'i18n';

const NoResults: React.FC = () => {
  return (
    <div className='no-results-container'>
      <img
        src='/assets/images/career-explorer/no-results-icon.svg'
        alt={intl.formatMessage(messages.noResultsFoundIconAltText)}
      />
      <div className='text-container'>
        <h4 className='title'>
          <WrappedMessage message={messages.noResultsFoundText} />
        </h4>
        <div className='description'>
          {/* this is a tempraroy text until more careers are not added, leaving untranslated */}
          Additional career profiles are currently in development. Please check
          back soon!
        </div>
      </div>
    </div>
  );
};

export default NoResults;
